export { EloMegaphoneIcon } from './megaphone-icon'
